module.exports = __webpack_public_path__ + "img/tenshi hinanawi_lw.fb28ed61.png";